import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useTheme } from "@mui/material/styles";

const INK = "#0F172A";
const MUTED = "#475569";
const BORDER = "#D9E2EC";

const PhoneField = ({
  value,
  onChange,
  error,
  gridSize = { xs: 12, md: 6 },
}) => {
  const theme = useTheme();

  return (
    <Grid item size={gridSize}>
      <Box
        sx={{
          "& .react-tel-input": { width: "100% !important" },
          "& .react-tel-input .form-control": { width: "100% !important" },
        }}
      >
        <Typography
          component="label"
          sx={{
            display: "block",
            mb: 0.6,
            ml: 0.25,
            fontSize: "0.88rem",
            fontWeight: 600,
            fontFamily: '"Inter", sans-serif',
            color: error ? theme.palette.error.main : MUTED,
            transition: "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
          }}
        >
          Phone Number
        </Typography>
        <PhoneInput
          country={"lk"}
          value={value}
          onChange={onChange}
          specialLabel=""
          inputStyle={{
            width: "100%",
            height: "56px",
            fontSize: "0.93rem",
            fontFamily: '"Inter", sans-serif',
            borderRadius: "12px",
            borderColor: error ? theme.palette.error.main : BORDER,
            borderWidth: error ? "2px" : "1.5px",
            backgroundColor: "#fff",
            color: INK,
          }}
          buttonStyle={{
            borderRadius: "12px 0 0 12px",
            borderColor: error ? theme.palette.error.main : BORDER,
            borderWidth: error ? "2px" : "1.5px",
            backgroundColor: "#fff",
          }}
          dropdownStyle={{
            backgroundColor: "#fff",
            color: INK,
          }}
          containerStyle={{
            fontFamily: '"Inter", sans-serif',
            width: "100%",
          }}
          enableSearch
          searchStyle={{
            width: "90%",
            backgroundColor: "#f8fafc",
            color: INK,
          }}
        />
        {error && (
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.error.main,
              mt: 0.5,
              ml: 1.75,
              display: "block",
              fontFamily: '"Inter", sans-serif',
            }}
          >
            {error}
          </Typography>
        )}
      </Box>
    </Grid>
  );
};

export default PhoneField;

